export default __webpack_public_path__ + "static/media/azure_resource_manager.d9682f6c.svg";